/*
 *  Copyright (C) 2017 Atelier Cartographique <contact@atelier-cartographique.be>
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, version 3 of the License.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import debug from 'debug';
import { setZoom, stopTracker } from 'embed/src/events/map';
import { getGpsTrackerIsActive, getView } from 'embed/src/queries/map';
import { getRoot } from 'sdi/app';
import { icon, makeLabelAndIcon } from 'sdi/components/button';
import { nameToString } from 'sdi/components/button/names';
import { A, DIV, H1, H2, SPAN } from 'sdi/components/elements';
import { legendRenderer } from 'sdi/components/legend';
import tr, { fromRecord } from 'sdi/locale';
import { IMapInfo } from 'sdi/source';
import {
    getDatasetMetadata,
    getLayerInfoList,
    getMapInfo,
} from '../../queries/app';

const logger = debug('sdi:legend');

const atlasLink = () =>
    getMapInfo().fold(DIV({}), mapInfo =>
        DIV(
            'link',
            icon('external-link-alt'),
            A(
                { href: `${getRoot()}view/map/${mapInfo.id}`, target: '_top' },
                tr.embed('atlasLinkLabel'),
            ),
        ),
    );

const renderTitle = () =>
    getMapInfo().fold(DIV({}), mapInfo =>
        DIV('map-title', H1({}, fromRecord(mapInfo.title))),
    );

const renderLegend = legendRenderer(getDatasetMetadata, getView, setZoom);

const btnStop = makeLabelAndIcon('close', 2, 'stop', () =>
    tr.embed('StopGpsTracker'),
);
const stopGpsTrackerBanner = () =>
    DIV(
        'tool-widget geo-tracker',
        DIV(
            'text__wrapper',
            SPAN('icon fa', nameToString('info-circle')),
            SPAN('label', ` ${tr.embed('gpsTrackerActivated')} : `),
            SPAN('value', tr.embed('helptext:gpsTracker')),
        ),
        btnStop(stopTracker),
    );

const legendLegend = (mapInfo: IMapInfo) =>
    DIV(
        'legend',
        renderTitle(),
        DIV('description', fromRecord(mapInfo.description)),
        getGpsTrackerIsActive() ? stopGpsTrackerBanner() : null,
        H2({}, tr.embed('mapLegend')),
        DIV('styles-wrapper', ...renderLegend(getLayerInfoList())),
        atlasLink(),
    );

const render = () => getMapInfo().fold(DIV({}), info => legendLegend(info));

export default render;

logger('loaded');
